// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__177Z4","titleStyle":"Box_titleStyle__3d96m","link":"Box_link__2bdKy"};